import styled from "@emotion/styled";

export const SparkleCircleImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
  height: 76px;
`;

export const ImageContainer = styled.div`
  border-radius: 99999px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000;
  box-shadow: 0px 2px 0px 0px #000;
  overflow: hidden;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const SparklesImageWrapper = styled.div`
  position: absolute;
  height: 92.1%;
  width: 131.57%;
  pointer-events: none;
`;
